import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { Permission } from 'src/WebApiController';

interface BulkBroadcastActionsPermission {
  hasBroadcastPermission: boolean;
  hasSellerAccountAdminPermission: boolean;
  hasAdminHoldPermission: boolean;
}

export const useBulkBroadcastActionsPermission =
  (): BulkBroadcastActionsPermission => {
    const hasBroadcastPermission = useUserHasAnyOfPermissions(
      Permission.Inventory_BroadcastUnbroadcast,
      Permission.Inventory_BroadcastUnbroadcastOnIsPricerOf,
      Permission.Inventory_BroadcastUnbroadcastOnPurchasedBy
    );

    const hasSellerAccountAdminPermission = useUserHasAnyOfPermissions(
      Permission.SellerAccount_Admin
    );

    const hasAdminHoldPermission = useUserHasAnyOfPermissions(
      Permission.Inventory_ManageAdminHolds
    );

    return {
      hasBroadcastPermission,
      hasSellerAccountAdminPermission,
      hasAdminHoldPermission,
    };
  };
